import React, { SyntheticEvent } from 'react';
import { Text, Preset, Color, Tag } from '@lux/text';
import { Translate } from '@pegasus/translation';

import * as S from './styles';

export interface ReservedPopoverProps {
    handleClick: (args: SyntheticEvent) => void;
}

export const ReservedPopover: React.FunctionComponent<ReservedPopoverProps> = ({ handleClick }) => (
    <S.ReservedWrapperPopover>
        <S.ReservedArticlePopover>
            <S.ReservedArticleHeadline preset={Preset.M} bold color={Color.dark} tag={Tag.DIV}>
                <Translate message="article.reservedPopoverHeadline" />
            </S.ReservedArticleHeadline>
            <S.ReservedArticleBody preset={Preset.S} color={Color.dark} tag={Tag.DIV}>
                <Translate message="article.reservedPopoverFirstLine" />
            </S.ReservedArticleBody>
            <S.ReservedArticleBody preset={Preset.S} color={Color.dark} tag={Tag.DIV}>
                <Translate message="article.reservedPopoverSecondLine" />
            </S.ReservedArticleBody>
            <S.ReservedArticleCloseSt onClick={handleClick}>
                <Text preset={Preset.S} color={Color.dark}>
                    <Translate message="marketingOverlays.close" />
                </Text>
            </S.ReservedArticleCloseSt>
        </S.ReservedArticlePopover>
    </S.ReservedWrapperPopover>
);

export default ReservedPopover;
